import React, { createContext, useState, ReactNode } from "react";

export interface WalletData {
  address: string;
  privateKey?: string;
  type: "metamask" | "passkey";
}

interface AppContextType {
  userWallet: WalletData | null;
  setUserWallet: (wallet: WalletData | null) => void;
  uploadedFile: File | null;
  setUploadedFile: (file: File | null) => void;
  nftName: string;
  setNftName: (name: string) => void;
  price: string;
  setPrice: (price: string) => void;
  nftMinted: boolean;
  setNftMinted: (minted: boolean) => void;
  nftBuyUrl: string;
  setNftBuyUrl: (url: string) => void;
  mintProgress: { percentage: number; estimate?: Date } | null;
  setMintProgress: (progress: { percentage: number; estimate?: Date } | null) => void;
}

export const AppContext = createContext<AppContextType>({
  userWallet: null,
  setUserWallet: () => {},
  uploadedFile: null,
  setUploadedFile: () => {},
  nftName: "",
  setNftName: () => {},
  price: "",
  setPrice: () => {},
  nftMinted: false,
  setNftMinted: () => {},
  nftBuyUrl: "",
  setNftBuyUrl: () => {},
  mintProgress: null,
  setMintProgress: () => {}
});

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [userWallet, setUserWallet] = useState<WalletData | null>(null);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [nftName, setNftName] = useState("");
  const [price, setPrice] = useState("");
  const [nftMinted, setNftMinted] = useState(false);
  const [nftBuyUrl, setNftBuyUrl] = useState("");
  const [mintProgress, setMintProgress] = useState<{ percentage: number; estimate?: Date } | null>(null);
  

  return (
    <AppContext.Provider
      value={{
        userWallet,
        setUserWallet,
        uploadedFile,
        setUploadedFile,
        nftName,
        setNftName,
        price,
        setPrice,
        nftMinted,
        setNftMinted,
        nftBuyUrl,
        setNftBuyUrl,
        mintProgress,
        setMintProgress
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

